export default {
  INTERNAL_ORDERS: "Internal orders",
  ESTABLISHMENT_INTERNAL_ORDERS_LIST: "Internal orders list",
  ADD_ESTABLISHMENT_INTERNAL_ORDER: "Add an internal order",
  ESTABLISHMENT_INTERNAL_ORDER_ADDED: "Internal order added",
  EDIT_ESTABLISHMENT_INTERNAL_ORDER: "Edit an internal order",
  ESTABLISHMENT_INTERNAL_ORDER_UPDATED: "Internal order updated",
  VIEW_ESTABLISHMENT_INTERNAL_ORDER: "View internal order",
  DELETE_ESTABLISHMENT_INTERNAL_ORDER: "Delete internal order",
  DELETE_THIS_ESTABLISHMENT_INTERNAL_ORDER: "Delete this internal order?",
  ESTABLISHMENT_INTERNAL_ORDER_DELETED: "Internal order deleted",

  STATUS_DRAFT: "Draft",
  STATUS_SUBMITTED: "Submitted",
  STATUS_CONFIRMED: "Confirmed",
  STATUS_PARTIALLY_INVOICED: "Partially invoiced",
  STATUS_COMPLETED: "Completed",
  STATUS_REJECTED: "Rejected",
  STATUS_CANCELED: "Canceled",

  INVOICING_STATUS_PENDING: "To invoice",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partially invoiced",
  INVOICING_STATUS_INVOICED: "Invoiced",
  INVOICING_STATUS: "Invoicing progress",

  WEEK: "Week",
  WEEK_STARTS_AT: "Week start (monday)",
  WEEK_ENDS_AT: "Week end (friday)",
  PRODUCTION_ESTABLISHMENT: "Production establishment",
  SATELLITE_ESTABLISHMENT: "Satellite establishment",
  PRODUCTION_CAFETERIA: "Production cafeteria",
  SATELLITE_CAFETERIA: "Satellite cafeteria",

  SUBMIT: "Validate and submit",
  SUBMIT_QUESTION: "Submit the internal order to the production establishment?",
  CONFIRM: "Confirm",
  CONFIRM_QUESTION: "Confirm this internal order?",
  CONFIRM_FREEZE_HINT: "The order will be frozen.",
  ESTABLISHMENT_INTERNAL_ORDER_SUBMITTED: "Internal order submitted",
  ESTABLISHMENT_INTERNAL_ORDER_CONFIRMED: "Internal order confirmed",
  REJECT: "Reject",
  REJECT_QUESTION: "Reject this internal order?",
  ESTABLISHMENT_INTERNAL_ORDER_REJECTED: "Internal order rejected",
  CANCEL_QUESTION: "Cancel this internal order?",
  ESTABLISHMENT_INTERNAL_ORDER_CANCELED: "Internal order canceled",
  REVERT_TO_DRAFT_QUESTION: "Move the internal order back to draft?",
  ESTABLISHMENT_INTERNAL_ORDER_REVERTED: "Internal order moved back to draft",
  ADD_ITEMS_FIRST: "Enter at least one quantity before submitting.",
  SUBMITTED_BY: "Submitted by",
  SUBMITTED_AT: "Submitted at",
  CONFIRMED_BY: "Confirmed by",
  CONFIRMED_AT: "Confirmed at",

  ITEMS_GRID: "Week grid",
  COPY_MONDAY_TO_WEEK: "Copy monday to the whole week",
  COPY_MONDAY_TO_WEEK_DONE: "Monday quantities copied to the week",
  DUPLICATE_PREVIOUS_WEEK: "Reuse previous week",
  DUPLICATE_PREVIOUS_WEEK_DONE: "Previous week quantities reused",
  NO_PREVIOUS_WEEK: "No internal order found for the previous week",
  TOTAL_QUANTITY: "Total qty",
  DAY_TOTAL: "Day total",
  WEEK_TOTAL: "Week total",

  TRACKING: "Tracking",
  ORDERED: "Ordered",
  INVOICED: "Invoiced",
  REMAINING: "Left to invoice",
  LINE_STATE_CONFORM: "Matching",
  LINE_STATE_PARTIAL: "Partial",
  LINE_STATE_NOT_RECEIVED: "Not received",
  LINE_STATE_OVER: "Over-received",

  INTERNAL_INVOICES: "Internal invoices",
  GENERATE_INVOICE_FOR_DAY: "Generate and submit the invoice of {day}",
  INVOICE_GENERATED: "Internal invoice generated and submitted for acceptance",
  DAY_FULLY_INVOICED: "Day invoiced",
  DAY_NOT_RECEIVED: "Day not received",
  NOTHING_LEFT_TO_INVOICE: "Nothing left to invoice for that day",

  DAILY_PREPARATIONS: "Daily preparations",
  DAILY_PREPARATIONS_LIST: "Daily preparations",
  DAILY_PREPARATIONS_HELP:
    "What production has to make and send today. Read-only screen: the internal invoice is keyed in by the receiving establishment.",
  PRINT_SENDING_SLIP: "Daily sending slip",
  PRINT_WEEK: "Print the week",
  AGGREGATED_BY_PRODUCT: "Total per product, all satellite cafeterias",
  NO_PREPARATION_FOR_DAY: "No preparation for that day",
  PRODUCTIONS_TO_MAKE: "Productions to make",
  PREPARATIONS_PERIOD: "Period",
  PRINT_PRODUCTION_LIST: "Print the list",
  CHOOSE_PRODUCTION_ESTABLISHMENT: "Choose the production establishment to see what it has to make.",
  WEEKLY_PREPARATIONS_HELP:
    "What the production kitchen has to make and send each day of the week, across all satellite cafeterias. Read-only screen: the internal invoice is entered by the receiving establishment.",
  WEEK_FROM_TO: "Week of {from} to {to}",
  NO_PREPARATION_FOR_WEEK: "No preparation for that week",
  NOTHING_TO_PRODUCE_TODAY: "Nothing to produce today.",
  SEE_TODAY: "See the day",
  SEE_WEEK: "See the week",
  ORDERS_TO_CONFIRM: "Internal orders to confirm",
  TO_PRODUCE_TODAY: "To produce and send today",
  REVERT_TO_DRAFT: "Revert to draft",
  LINES: "Lines",
  ESTABLISHMENT_TAB_HELP: "This list holds the internal orders of the establishment, whether it is the source (production) or the destination (satellite).",
  ADD_FROM_ESTABLISHMENT_HELP: "{establishment} is the ordering establishment (satellite). Pick its production establishment.",
  ESTABLISHMENT_NOT_SATELLITE: "{establishment} hosts no cafeteria of type “Satellite”: placing internal orders normally requires a satellite cafeteria. You may still create an order, but check the cafeteria setup first.",
  ESTABLISHMENT_NOT_PRODUCTION: "{establishment} hosts no cafeteria of type “Production”: it therefore cannot be picked as the production establishment of another establishment's internal order.",
  NO_SATELLITE_CAFETERIA_WARNING: "This establishment hosts no cafeteria of type “Satellite”. Normally only an establishment with a satellite cafeteria places internal orders. Creation is still possible.",
  NO_PRODUCTION_ESTABLISHMENT_WARNING: "No establishment with a cafeteria of type “Production” was found. Set up a production cafeteria before creating internal orders.",
  SEND_BY_MAIL: "Send by e-mail",
  SEND_NOW_QUESTION: "Send the internal order now?",
  SEND_NOW_HINT: "You may e-mail the order to the production establishment right away so it is not forgotten.",
  MAIL_SENT_AT: "Sent at",
  MAIL_SENT_BY: "Sent by",
  CONFIRM_BEFORE_INVOICING: "Confirm the order before invoicing",
  DISCOUNT: "Rebate",
  AUTHOR_CANNOT_DECIDE: "You created or submitted this order: confirming or rejecting it is up to the production establishment.",
  PRODUCTION_HAS_NO_WAREHOUSE: "The production establishment has no warehouse attached: the orderable products cannot be listed. Attach a warehouse to that establishment.",
  RECEIVED: "Received",
  GENERATE_INVOICE: "Generate and submit",
  DECLARE_NOT_RECEIVED: "Declare the day not received",
  NOT_RECEIVED_HINT:
    "Every quantity is 0: the day will be declared not received. A 0 $ invoice will close it, and the production establishment will accept it once it has read the reason.",
  GENERATE_INVOICE_MODAL_HELP: "Adjust the received quantities: the internal invoice will be generated then submitted right away for acceptance. They are prefilled with what is left to invoice for that day; set 0 on a line that was not received. The invoice is dated on that ordered day, whatever the day you generate it on.",
  OVER_RECEPTION_HINT: "One quantity exceeds what is left to invoice: that line will be flagged as over-received in the tracking tab.",
  VIEW_INTERNAL_ORDER: "View the internal order",
  INTERNAL_ORDERS_MENU: "Internal order",
  TRACKING_WIDGET_TITLE: "Internal orders tracking",
  TRACKING_WIDGET_TO_PROCESS: "To process — production side",
  TRACKING_WIDGET_IN_PROGRESS: "In progress — satellite side",
  REMAINING_DAYS: "Days left to invoice",
};
